import { render, staticRenderFns } from "./booklet-editor.vue?vue&type=template&id=b84692ce"
import script from "./booklet-editor.vue?vue&type=script&lang=ts"
export * from "./booklet-editor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports